"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ant-design/icons");
var _react = _interopRequireDefault(require("react"));
var getItem = function getItem(label, key, icon, children, type) {
  return {
    key: key,
    icon: icon,
    children: children,
    label: label,
    type: type
  };
};
var items = [getItem('Navigation One', 'sub1', /*#__PURE__*/_react.default.createElement(_icons.MailOutlined, null), [getItem('Item 1', 'g1', null, [getItem('Option 1', '1'), getItem('Option 2', '2')], 'group'), getItem('Item 2', 'g2', null, [getItem('Option 3', '3'), getItem('Option 4', '4')], 'group')]), getItem('Navigation Two', 'sub2', /*#__PURE__*/_react.default.createElement(_icons.AppstoreOutlined, null), [getItem('Option 5', '5'), getItem('Option 6', '6'), getItem('Submenu', 'sub3', null, [getItem('Option 7', '7'), getItem('Option 8', '8')])]), getItem('Navigation Three', 'sub4', /*#__PURE__*/_react.default.createElement(_icons.SettingOutlined, null), [getItem('Option 9', '9'), getItem('Option 10', '10'), getItem('Option 11', '11'), getItem('Option 12', '12')])];
var _default = exports.default = items;